import { storableError } from '../../util/errors';
import { fetchSeoVenuePage } from '../../util/seoDiscoveryFetch';

export const FETCH_VENUE_REQUEST = 'app/SeoDiscoveryVenuePage/FETCH_REQUEST';
export const FETCH_VENUE_SUCCESS = 'app/SeoDiscoveryVenuePage/FETCH_SUCCESS';
export const FETCH_VENUE_ERROR = 'app/SeoDiscoveryVenuePage/FETCH_ERROR';

const initialState = {
  payload: null,
  fetchInProgress: false,
  fetchError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case FETCH_VENUE_REQUEST:
      return { ...state, fetchInProgress: true, fetchError: null };
    case FETCH_VENUE_SUCCESS:
      return { ...state, fetchInProgress: false, payload };
    case FETCH_VENUE_ERROR:
      return { ...state, fetchInProgress: false, fetchError: payload };
    default:
      return state;
  }
}

const fetchRequest = () => ({ type: FETCH_VENUE_REQUEST });
const fetchSuccess = payload => ({ type: FETCH_VENUE_SUCCESS, payload });
const fetchError = e => ({ type: FETCH_VENUE_ERROR, payload: storableError(e) });

export const loadVenueData = venueSlug => dispatch => {
  dispatch(fetchRequest());
  return fetchSeoVenuePage(venueSlug)
    .then(data => dispatch(fetchSuccess(data)))
    .catch(e => {
      dispatch(fetchError(e));
      throw e;
    });
};

export const loadData = (params, search, config) => dispatch => {
  const slug = params?.venueSlug;
  if (!slug) {
    return Promise.resolve();
  }
  return dispatch(loadVenueData(slug));
};
